import Farm from "@/farm/Farm"
import Employee from "@/employee/Employee"
import { serializable, serialize } from "serializr"
import EffectType from "@/effects/EffectType"
import ValueMod from "@/effects/ValueMod"

export default class Office {
  private farm: Farm
  private staff: Employee[] = []

  @serializable
  tmp: number = 0 // Just to make this class serializable

  // @ts-ignore
  constructor(farm: Farm = undefined) {
    this.farm = farm
  }

  load(state: any) {

  }

  update(dt: number) {
    this.staff = this.farm.getEmployeesAssignedTo('office')

    this.autoMilk(dt)
    this.improveConsumption(dt)
  }

  improveConsumption(dt: number) {
    // First remove all temp effects
    for (let i = 0; i < this.farm.state.staffLimit.max; i++) {
      this.farm.state.effectManager.removeTempEffect(`office-worker-${i}`, 'milkConsumption')

      // v1.0.0
      this.farm.state.effectManager.removeTempEffect(`office-worker-${i}`, 'milkPrice')
    }

    // Then add back in the ones we want
    for (let [i, worker] of this.salesStaff.entries()) {
      this.farm.state.effectManager.addTempEffect(`office-worker-${i}`, 'milkConsumption',
        worker.milkConsumptionIncrease,
        new EffectType(5, 'slow', 'temporary')
      )
    }
  }

  autoMilk(dt: number) {
    for (let worker of this.milkStaff) {
      // Create a sorted copy of the employees list, sorted from most milk to least milk
      let cows: Employee[] = this.farm.state.employees.slice(0, this.farm.state.employees.length)
        .sort((a, b) => {
          return b.milk.fraction - a.milk.fraction
        }) as Employee[]

      // Milk the first cow that is not the worker and isn't being milked by player
      for (let cow of cows) {
        if (cow.uuid != worker.uuid && !cow.isBeingMilked && cow.milk.max > 0.05) {
          this.farm.milk(dt, cow, { worker: worker })
          break
        }
      }
    }
  }

  private getStaff(officeTask: string) {
    let staff: Employee[] = []
    for (let worker of this.staff) {
      if (worker.officeTask == officeTask) {
        staff.push(worker)
      }
    }
    return staff
  }

  get milkStaff(): Employee[] {
    return this.getStaff('milking')
  }

  get salesStaff(): Employee[] {
    return this.getStaff('sales')
  }

  toJSON() {
    return serialize(this)
  }
}
